import { formatCustomer } from './formatCustomer';

// Собираем визуальный preview suffix в том же порядке, что и на backend:
// сначала системный параметр a, затем tag, затем пользовательский suffix.
export const buildFinalUrlSuffixPreview = ({
  customerId,
  customerIdPlaceholder,
  appendTag,
  customUtm,
  finalUrlSuffix,
}: {
  customerId?: string | null;
  customerIdPlaceholder?: string;
  appendTag: boolean;
  customUtm?: string | null;
  finalUrlSuffix?: string | null;
}) => {
  const normalizedCustomerId = String(customerId || '').replace(/\D/g, '');
  const normalizedTag = String(customUtm || '').trim();
  const normalizedSuffix = String(finalUrlSuffix || '')
    .trim()
    .replace(/^[?&]+/, '');

  const displayCustomerId =
    formatCustomer(normalizedCustomerId) || customerIdPlaceholder || '{customer_id}';

  const parts = [`a=${displayCustomerId}`];

  if (normalizedTag) {
    parts.push(`tag=${normalizedTag}`);
  } else if (appendTag) {
    parts.push('tag={auto}');
  }

  if (normalizedSuffix) {
    parts.push(normalizedSuffix);
  }

  return parts.join('&');
};
